import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, carInit, GET_CAR, PUT_CAR } from "../../../constant-value";
import { carSchema } from "../../../constant-value/schema";
import { IoChevronBackCircle, IoChevronBackOutline } from "react-icons/io5";
import alphabet from "../../../constant-value/alphaet.json";
import { toast } from "react-toastify";
import api from "../../../services/axiosConfig";
import { motion } from "framer-motion";

const EditCar = () => {
  const { id } = useParams();
  const [car, setCar] = useState(carInit);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);

  const navigate = useNavigate();

  const closeHandler = () => {
    navigate(-1);
  };

  useEffect(() => {
    api
      .get(`${BASE_URL}${GET_CAR}${id}`)
      .then((res) => {
        setCar({
          title: res.data.title,
          pelak1: res.data.pelak14Edit,
          pelak2: res.data.pelak2,
          pelak3: res.data.pelak34Edit,
          pelak4: res.data.pelak44Edit,
          shasiNo: res.data.shasiNo,
          productYear: res.data.productYear4Edit,
          kilometer: res.data.kilometer4Edit,
          useFuel: res.data.useFuel4Edit,
          company: res.data.company,
          distancePerWeek: res.data.distancePerWeek4Edit,
          userId: res.data.userId,
          imageUrl: res.data.imageUrl,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  const message = (message, type) => {
    if (type === "warn") {
      toast.warning(message, { autoClose: 1500 });
    } else {
      toast.success(message, { autoClose: 1500 });
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    dirty,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...car,
      useFuel: car.useFuel?.toString() || "",
      kilometer: car.kilometer?.toString() || "",
      distancePerWeek: car.distancePerWeek?.toString() || "",
      pelak1: car.pelak1?.toString() || "",
      pelak2: car.pelak2?.toString() || "",
      pelak3: car.pelak3?.toString() || "",
      pelak4: car.pelak4?.toString() || "",
    },
    validationSchema: carSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
        useFuel: parseFloat(values.useFuel),
        kilometer: parseFloat(values.kilometer),
        distancePerWeek: parseFloat(values.distancePerWeek),
        pelak1: parseInt(values.pelak1),
        pelak2: parseInt(values.pelak2),
        pelak3: parseInt(values.pelak3),
        pelak4: parseInt(values.pelak4),
      };

      const fd = new FormData();

      // فیلدها
      Object.keys(payload).forEach((key) => {
        fd.append(key, payload[key] ?? "");
      });

      // فایل تصویر
      if (selectedFile) {
        if (!selectedFile.type.startsWith("image/")) {
          toast.error("فقط فایل تصویری مجاز است!");
          return;
        }
        if (selectedFile.size > 2 * 1024 * 1024) {
          toast.error("حجم تصویر نباید بیشتر از 2 مگابایت باشد!");
          return;
        }
        fd.append("file", selectedFile);
      }

      api
        .put(`${PUT_CAR}${id}`, fd)
        .then((res) => {
          if (res.data.isSuccess) {
            navigate(-1);
            message(res.data.message, "success");
          } else {
            message(res.data.message, "warn");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  });

  if (isLoading) return <div>در حال بارگذاری...</div>;

  return (
    <Fragment>
      <div className="container py-3">
        <div className="row">
          <div className="col-12 position-relative">
            <h2 className="text-center mb-4">ویرایش خودرو</h2>
            <div className="position-absolute top-0 end-0">
              <motion.button
                type="button"
                className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "36px", height: "36px" }}
                onClick={closeHandler}
                aria-label="بازگشت"
                whileHover={{ scale: 1.15, rotate: -10 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 300, damping: 10 }}
              >
                <IoChevronBackOutline size={20} />
              </motion.button>
            </div>
          </div>
        </div>

        <form className="card p-3" onSubmit={handleSubmit}>
          <div className="row">
            {/* ستون اول */}
            <div className="col-md-6">

              {/* Car Image */}
              <div className="col-md-6 text-center mb-4">
                <img
                  src={
                    selectedFile
                      ? URL.createObjectURL(selectedFile)
                      : values.imageUrl || BASE_URL + "/Images/Car/car.png"
                  }
                  alt="profile"
                  className="rounded-circle shadow-sm mb-2"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                  }}
                />
                <div>
                  <label className="btn btn-outline-primary btn-sm mt-2">
                    انتخاب تصویر
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setSelectedFile(file);
                          setFieldValue("image", file);
                        }
                      }}
                    />
                  </label>
                </div>
              </div>

              {/* نام خودرو */}
              <div className="mb-3 form-floating">
                <input
                  value={values.title || ""}
                  onChange={handleChange}
                  id="title"
                  name="title"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.title && touched.title ? "is-invalid" : ""
                  }`}
                  placeholder="نام خودرو"
                />
                <label htmlFor="title">نام خودرو</label>
                {errors.title && touched.title && (
                  <div className="invalid-feedback">{errors.title}</div>
                )}
              </div>

              {/* شرکت سازنده */}
              <div className="mb-3 form-floating">
                <input
                  value={values.company || ""}
                  onChange={handleChange}
                  id="company"
                  name="company"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.company && touched.company ? "is-invalid" : ""
                  }`}
                  placeholder="شرکت سازنده"
                />
                <label htmlFor="company">شرکت سازنده</label>
                {errors.company && touched.company && (
                  <div className="invalid-feedback">{errors.company}</div>
                )}
              </div>

              {/* سال ساخت */}
              <div className="mb-3 form-floating">
                <input
                  value={values.productYear || ""}
                  onChange={handleChange}
                  id="productYear"
                  name="productYear"
                  inputMode="numeric"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.productYear && touched.productYear ? "is-invalid" : ""
                  }`}
                  placeholder="سال ساخت"
                />
                <label htmlFor="productYear">سال ساخت</label>
                {errors.productYear && touched.productYear && (
                  <div className="invalid-feedback">{errors.productYear}</div>
                )}
              </div>

              {/* شماره شاسی */}
              <div className="mb-3 form-floating">
                <input
                  value={values.shasiNo || ""}
                  onChange={handleChange}
                  id="shasiNo"
                  name="shasiNo"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.shasiNo && touched.shasiNo ? "is-invalid" : ""
                  }`}
                  placeholder="شماره شاسی"
                />
                <label htmlFor="shasiNo">شماره شاسی</label>
                {errors.shasiNo && touched.shasiNo && (
                  <div className="invalid-feedback">{errors.shasiNo}</div>
                )}
              </div>
            </div>

            {/* ستون دوم */}
            <div className="col-md-6">
              {/* مصرف سوخت */}
              <div className="mb-3 form-floating">
                <input
                  value={values.useFuel || ""}
                  onChange={handleChange}
                  id="useFuel"
                  name="useFuel"
                  inputMode="numeric"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.useFuel && touched.useFuel ? "is-invalid" : ""
                  }`}
                  placeholder="مصرف سوخت در 100 کیلومتر"
                />
                <label htmlFor="useFuel">مصرف سوخت در 100 کیلومتر</label>
                {errors.useFuel && touched.useFuel && (
                  <div className="invalid-feedback">{errors.useFuel}</div>
                )}
              </div>

              {/* کیلومتر فعلی */}
              <div className="mb-3 form-floating">
                <input
                  value={values.kilometer || ""}
                  onChange={handleChange}
                  id="kilometer"
                  name="kilometer"
                  inputMode="numeric"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.kilometer && touched.kilometer ? "is-invalid" : ""
                  }`}
                  placeholder="کیلومتر فعلی km"
                />
                <label htmlFor="kilometer">کیلومتر فعلی km</label>
                {errors.kilometer && touched.kilometer && (
                  <div className="invalid-feedback">{errors.kilometer}</div>
                )}
              </div>

              {/* متوسط حرکت هفتگی */}
              <div className="mb-3 form-floating">
                <input
                  value={values.distancePerWeek || ""}
                  onChange={handleChange}
                  id="distancePerWeek"
                  name="distancePerWeek"
                  inputMode="numeric"
                  onBlur={handleBlur}
                  className={`form-control ${
                    errors.distancePerWeek && touched.distancePerWeek
                      ? "is-invalid"
                      : ""
                  }`}
                  placeholder="متوسط حرکت (هفتگی) km"
                />
                <label htmlFor="distancePerWeek">متوسط حرکت (هفتگی) km</label>
                {errors.distancePerWeek && touched.distancePerWeek && (
                  <div className="invalid-feedback">
                    {errors.distancePerWeek}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* پلاک */}
          <div className="row">
            <div className="col-12 mb-4">
              <label className="form-label mb-2">پلاک</label>
              <div className="d-flex flex-wrap justify-content-between">
                <div className="col-3 col-md-2 p-1">
                  <input
                    value={values.pelak4 || ""}
                    onChange={handleChange}
                    id="pelak4"
                    name="pelak4"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control text-center ${
                      errors.pelak4 && touched.pelak4 ? "is-invalid" : ""
                    }`}
                  />
                </div>
                <div className="col-3 col-md-2 p-1">
                  <input
                    value={values.pelak3 || ""}
                    onChange={handleChange}
                    id="pelak3"
                    name="pelak3"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control text-center ${
                      errors.pelak3 && touched.pelak3 ? "is-invalid" : ""
                    }`}
                  />
                </div>
                <div className="col-3 col-md-2 p-1">
                  <select
                    id="pelak2"
                    name="pelak2"
                    onChange={handleChange}
                    value={values.pelak2 || ""}
                    className="form-select text-center"
                  >
                    {alphabet.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-3 col-md-2 p-1">
                  <input
                    value={values.pelak1 || ""}
                    onChange={handleChange}
                    id="pelak1"
                    name="pelak1"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control text-center ${
                      errors.pelak1 && touched.pelak1 ? "is-invalid" : ""
                    }`}
                  />
                </div>
              </div>
              {(errors.pelak1 || errors.pelak3 || errors.pelak4) &&
                (touched.pelak1 || touched.pelak3 || touched.pelak4) && (
                  <div className="invalid-feedback d-block">
                    {errors.pelak1 || errors.pelak3 || errors.pelak4}
                  </div>
                )}
            </div>
          </div>

          {/* دکمه ارسال */}
          <div className="d-grid mt-4">
            <button
              type="submit"
              disabled={isSubmitting || !dirty}
              className="btn btn-primary py-2"
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  در حال ثبت...
                </>
              ) : (
                "ثبت اطلاعات"
              )}
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default EditCar;
